<template>
	<section>
		<el-row :gutter="20">
			<el-col :span="12" :offset="6">
				<el-form :model="account" :rules="rule" ref="account" label-width="200px">
					<el-form-item label="Old Password" prop="old">
						<el-input type="password" v-model="account.old"></el-input>
					</el-form-item>
					<el-form-item label="New Password" prop="new">
						<el-input type="password" v-model="account.new"></el-input>
					</el-form-item>
					<el-form-item label="Confirm Password" prop="confirm">
						<el-input type="password" v-model="account.confirm"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="changePassword" :loading="loading">Save</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

	</section>
</template>


<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import {changePassword} from "../../api/securityService";

    export default {
		data() {
			return {
                loading:false,
				account:{
					old:"",
					new:"",
					confirm:""
				},
                rule: {
                    old: [
                        { required: true, message: 'Old password is required.', trigger: 'blur' }
                    ],
                    new: [
                        { required: true, message: 'New Password is required.', trigger: 'blur' }
                    ],
                    confirm:[
                        { required: true, message: 'Confirm Password is required.', trigger: 'blur' },
                        { validator: this.confirmPassword, trigger: 'blur' }
                    ]
                }
			}
		},
		methods: {
            confirmPassword:function(rule, value, callback){
                if(this.account.new===this.account.confirm){
                    callback();
                }else{
                    callback(new Error('Please confirm Password.'));
                }
            },
		    changePassword(){
				this.$refs.account.validate((valid)=>{
				    if(valid){
				        this.loading = true;
				        let user = JSON.parse(sessionStorage.getItem("user"));
				        let param = {
				            username:user.username,
							password:this.account.old,
                            newPassword:this.account.new,
                            reNewPassword:this.account.confirm
						};
				        changePassword(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$refs.account.resetFields();
                                this.$message({
                                    message: res.message,
                                    type: 'Password changed success, Please login again.'
                                });
                                setTimeout(()=>{
                                    sessionStorage.removeItem('user');
                                    sessionStorage.removeItem('authorization');
                                    window.location.href = "/";
								},3000)
                            }else{
                                this.$message({
                                    message: res.message,
                                    type: 'error'
                                })
                            }
						}).catch((res)=>{
						    console.log(res);
						    this.loading = false;
						})
					}
				})
			}
		},
		mounted() {
			//this.getUsers();
		}
	}

</script>


// WEBPACK FOOTER //
// password.vue?c91bd9cc